export default __webpack_public_path__ + "static/media/setaVermelha.38fa6889.svg";